/* ============
 * Vee Validate
 * ============
 *
 * Plugin that allows you to validate input fields, and display errors, in an easy and powerful way.
 *
 * http://vee-validate.logaretm.com/
 */

import Vue from 'vue'
import VeeValidate from 'vee-validate'

Vue.use(VeeValidate)



// WEBPACK FOOTER //
// ./src/app/plugins/vee-validate.js